import { API_BASE } from '../config';

interface StorageInfo {
  usedBytes: number;
  quotaBytes: number;
  usedMb: number;
  quotaMb: number;
}

export const fetchStorageInfo = async (token: string): Promise<StorageInfo> => {
  const response = await fetch(`${API_BASE}/api/settings/storage`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch storage info');
  }

  return await response.json();
};

export const wouldExceedStorageQuota = async (token: string, fileSize: number): Promise<boolean> => {
  try {
    const storageInfo = await fetchStorageInfo(token);
    return storageInfo.usedBytes + fileSize > storageInfo.quotaBytes;
  } catch (error) {
    console.error('Error checking storage quota:', error);
    return false;
  }
};

